import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/ticket/v3/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ticket3AgentManagementApi = {
  getRealTimePerformance: (request) => {
    const { params } = request
    // {
    //   date: String // today YYYY-MM-DD
    //   page_id: String
    // }
    return instance().get(`/analytic/overview/real-time-performance`, { params })
  },
  getReportOverview: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/overview?`, {
      params
    })
  },
  getTicketCardCounts: (request) => {
    const { params } = request
    // pageid
    // startTime
    // endTime
    // role
    // channel
    // search_page_id
    return instance().get(`/ticket-card-counts`, {
      params,
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  getChatlogCountAgentBot: (request) => {
    const { params } = request
    // "page_id": "116388304732570",
    // "start_date": "2022-08-31",
    // "end_date": "2023-08-31",
    // "search_page_id": "116388304732570",
    // "channel": "facebook"
    return instance().get(`/analytic/overview/number-case-agent-bot`, {
      params
    })
  },
  getTopWrapUp: (request) => {
    const { params } = request
    return instance().get(`/analytic/overview/top-five-question`, {
      params
    })
  },
  getAverageResponseTime: (request) => {
    const { params } = request
    // "page_id": "116388304732570",
    // "start_date": "2022-08-31",
    // "end_date": "2023-08-31",
    // "search_page_id": "116388304732570",
    // "channel": "facebook"
    return instance().get(`/analytic/overview/average-response-time`, {
      params
    })
  },
  getCountTicketStatusByAgent: (request) => {
    const { params } = request
    return instance().get(`/analytic/agent-performance/count-ticket-status-by-agent`, {
      params
    })
  },
  getCountTicketClosedByAgent: (request) => {
    const { params } = request
    return instance().get(`/analytic/agent-performance/count-ticket-assign-closed`, {
      params
    })
  },
  geNumberOfCaseStatus: (request) => {
    const { params } = request
    return instance().get(`/analytic/overview/number-case-status`, {
      params
    })
  },
  getNumberOfCloseCaseDetailAdmin: (request) => {
    const { params } = request
    return instance().get(`/analytic/overview/number-close-case-detail-admin`, {
      params
    })
  },
  getAgentPerformanceCheckInCheckOutHistory: (request) => {
    const { params } = request
    return instance().get(`/analytic/agent-performance/check-in-check-out-history`, {
      params
    })
  },
  getAgentWorkTime: (request) => {
    const { params } = request
    return instance().get(`/analytic/agent-performance/agent-work-time`, {
      params
    })
  },
  getCountAgentOnlineOffline: (request) => {
    const { params } = request
    return instance().get(`/analytic/agent-performance/count-agent-status-check-in-check-out`, {
      params
    })
  }
}

export default ticket3AgentManagementApi



// WEBPACK FOOTER //
// ./src/api/ticket3/agent-management.js